import React, { useState } from "react";
import Nav from "../../Component/NavBar/Nav";
import Footer from "../../Component/footer/Footer";
import StaticMap from "./StaticMap";
import stores from "../../data/store";
import SearchStore from "./SearchStore";
import "./location.css";

function Location() {
  const [nearestStores, setNearestStores] = useState([]);
  return (
    <div>
      <Nav />
      <div className="location-container">
        <SearchStore onNearestStores={setNearestStores} />
        <StaticMap
          locations={nearestStores.length > 0 ? nearestStores : stores}
        />
      </div>

      <Footer />
    </div>
  );
}

export default Location;
